<template>
  <layout-main-inner
    title="仓库管理"
    :showBack="!enable">
    <div slot="action">
      <el-button
        v-if="enable"
        type="primary"
        @click="editItem({})">新增仓库</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.warehouseName"
          clearable
          placeholder="请输入仓库名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        v-loading="loading"
        border
        :data="list">
        <el-table-column
          type="index"
          width="50"></el-table-column>
        <el-table-column
          label="仓库编号"
          width="120"
          prop="warehouseNo"></el-table-column>
        <el-table-column
          label="仓库名称"
          min-width="200"
          prop="warehouseName"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          :width="enable ? 150 : 90">
          <template slot-scope="{ row }">
            <el-button
              v-if="enable"
              type="text"
              @click="editItem(row)">修改</el-button>
            <el-button
              v-if="enable"
              type="text"
              @click="deleteItem(row)">删除</el-button>
            <el-button
              type="text"
              @click="viewBinSet(row)">库位管理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
    <warehouse-edit-modal
      ref="warehouse"
      @fetch="fetchList" />

    <binset-modal
      ref="binset"
      :enable="enable" />
  </layout-main-inner>
</template>
<script>
import Wms from '@/service/wms'
import WarehouseEditModal from '../base/busi/warehouse/warehouse-edit-modal.vue'
import BinsetModal from '../base/busi/warehouse/binset/binset-modal.vue'
export default {
  name: 'WarehouseList',
  components: { WarehouseEditModal, BinsetModal },
  props: { enable: { type: Boolean, default: true }},
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, warehouseName: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    viewBinSet(row) {
      const { warehouseId, warehouseName } = row
      this.$refs.binset.fetch({ warehouseId, warehouseName })
    },
    editItem(row) {
      this.$refs.warehouse.init({ ...row })
    },
    deleteItem(row) {
      this.$confirm('此操作将永久删除该仓库, 是否继续?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Wms.deletewarehouse({ warehouseId: row.warehouseId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if (result === 0) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    onClosed() {
      this.config = { ...this.config, ...this.$options.data().config }
      this.total = 0
      this.list = []
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Wms.getwarehouses({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if (result === 0) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
